import { Divider as AntdDivider, DividerProps } from "antd";
import { FC } from "react";

interface DProps extends DividerProps {
    children?: JSX.Element | JSX.Element[] | React.ReactNode | React.ReactNode[];
}

const Divider:FC<DProps> = ({ children, ...props}) => {
    return (
        <AntdDivider {...props}>{children}</AntdDivider>
    )
}
export default Divider;